export default __webpack_public_path__ + "static/instance-metrics-01-be65c27ddc09de414223d87dce907db7.png";